import { useCallback, useEffect, useState } from "react";
import { APP_VERSION } from "../../version.ts";

const POLL_INTERVAL_MS = 5 * 60 * 1000;
const IS_DEV_BUILD = APP_VERSION.commit === "dev";

async function fetchLatestCommit(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });
    if (!res.ok) return null;
    // If the server falls back to index.html, this throws and we ignore it
    const data = await res.json();
    return typeof data.commit === "string" ? data.commit : null;
  } catch {
    return null;
  }
}

export default function UpdateBanner() {
  const [outdated, setOutdated] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const check = useCallback(async () => {
    const latest = await fetchLatestCommit();
    console.log("Version check:", { running: APP_VERSION.commit, latest });
    if (latest && latest !== APP_VERSION.commit) setOutdated(true);
  }, []);

  useEffect(() => {
    if (IS_DEV_BUILD) return;

    check();
    const interval = setInterval(check, POLL_INTERVAL_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [check]);

  if (!outdated || dismissed) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-[99999] flex -translate-x-1/2 items-center gap-4 rounded-lg bg-[#243095] px-5 py-3 text-sm text-white shadow-lg"
    >
      <span>Налична е нова версия на приложението.</span>
      <button
        onClick={() => window.location.reload()}
        className="rounded bg-[#3C50E0] px-3 py-1 font-medium hover:opacity-90"
      >
        Презареди
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="text-white/70 hover:text-white"
      >
        По-късно
      </button>
    </div>
  );
}
